export const alerts = (state = '', action) => {
    switch (action.type) {
        case 'UPDATE':
            return action.alertElement;
        default:
            return state;
    }
};

export const alertShown = (state = { isOpen: false, type: 'color' }, action) => {
    switch (action.type) {
        case 'TOGGLE_OFF':
            return false;
        case 'TOGGLE_NO':
            return true;
        case 'TOGGLE':
            return { isOpen: !state.isOpen, type: action.alertType };
        default:
            return state;
    }
};

export const alertForStep = (state, action) => {
    return action;
};
